const module = { name: 'desktop/shared/amenityDropdown', exports: {} }; const exports = module.exports;



import { default as $ } from 'swug-fdRequire-call:jQuery';



import { Fandango_dropdown as dropdown } from 'base-libraries';



import { swig as swig } from 'require-core';



const Selectors = {
    AMENITY: '.js-amenity',
    AMENITY_CONTAINER: '#theater-showtimes-amenity',
}


const Styles = {
    AMENITIES_CONTAINER: 'theater-amenities-dropdown__container',
    CLOSE_BTN: 'theater-amenities-dropdown__close-btn',
}
function onClick() {
    const { amenityString, amenityDesc, amenityName: name, dropdownName, theaterId, type } = this.dataset;
    const description = amenityString === 'true' ? amenityDesc.split(',') : amenityDesc;
    const generatedDropdownName = dropdownName || Date.now();
    this.dataset.dropdownName = generatedDropdownName;
    const markup = swig.render('_theaterAmenitiesDropdown', {
        description,
        isString: typeof description === 'string',
        name,
        theaterId,
        type
    });
    dropdown.open(markup, {
        closeBtnParent: `${Selectors.AMENITY_CONTAINER}-${theaterId}--${type}`,
        closeBtnStyle: Styles.CLOSE_BTN,
        dropdownStyle: Styles.AMENITIES_CONTAINER,
        name: generatedDropdownName,
        openParent: this.id,
        relativeParent: this.parentNode,
    });
}
function run() {
    $(Selectors.AMENITY).on('click', onClick);
}
module.exports = {
    run
};
export default module.exports;